import { ReactNode } from 'react';

import {
  SvgArea,
  SvgBeach,
  SvgManagement,
  SvgReception,
  SvgView,
} from '@/lib/shared/icons/complex-info';

export const conciergeStatsIcons: Record<string, ReactNode> = {
  'years-phuket': <SvgBeach />,
  'happy-clients': <SvgReception />,
  'expert-years': <SvgManagement />,
  'requests-year': <SvgView />,
  'all-services': <SvgArea />,
} as const;
